import { Textarea } from 'baseui/textarea';
import get from 'lodash/get';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import uniq from 'lodash/uniq';
import { styled } from 'baseui';
import React, { PureComponent } from 'react';
import type { QnAStateType, QuestionType } from '../../reducers';
import type { UpdateNotePayload } from '../../actions';
import type { UserAnswersT } from '../../reducers/answers';
import { getUserNoteByQuestionId } from '../../reducers/selectors';
type PropsT = {
  state: QnAStateType;
  question: QuestionType;
  updateNote: (a: UpdateNotePayload) => void;
  userAnswers: UserAnswersT;
};
type StateT = {
  noteRule: 'none' | 'required' | 'optional';
  lastUserAnswer: string;
};
const Wrap = styled('div', {
  marginTop: '5px'
});
const getFirstAnswerStringFromUserAnswers = (userAnswers: UserAnswersT): string => (userAnswers[0] instanceof File ? userAnswers[0].name : userAnswers[0]) || '';
export default class UserNote extends PureComponent<PropsT, StateT> {
  constructor(props: PropsT, context: void) {
    super(props, context);
    const {
      userAnswers
    } = this.props;
    this.state = {
      // @ts-expect-error todo(ts-migration) TS2322 Type 'string' is not assignable to type '"none" | "required" | "optional"'.
      noteRule: UserNote.getNoteRule(this.props),
      lastUserAnswer: getFirstAnswerStringFromUserAnswers(userAnswers)
    };
  }
  static getNoteRule(props: PropsT) {
    const {
      question,
      userAnswers
    } = props;
    const answerOptions = get(question, 'answers');

    // find out if note is needed
    const noteTypesForSelectedAnswers = uniq(answerOptions.filter(answerItem => userAnswers.includes(answerItem.answer)).map(answerItem => answerItem.note));
    let noteRule = 'none';
    if (includes(noteTypesForSelectedAnswers, 'required')) {
      noteRule = 'required';
    } else if (includes(noteTypesForSelectedAnswers, 'optional')) {
      noteRule = 'optional';
    }
    return noteRule;
  }
  static getDerivedStateFromProps(props: PropsT, state: StateT) {
    const {
      question,
      userAnswers
    } = props;
    const lastUserAnswer = getFirstAnswerStringFromUserAnswers(userAnswers);
    const noteRule = UserNote.getNoteRule(props);
    if (lastUserAnswer !== state.lastUserAnswer && noteRule === 'none') {
      const {
        updateNote
      } = props;
      const questionId = get(question, 'id');
      updateNote({
        questionId,
        note: ''
      });
    }
    return {
      noteRule,
      lastUserAnswer
    };
  }
  render() {
    const {
      state,
      updateNote,
      question,
      userAnswers
    } = this.props;
    const questionId = get(question, 'id');
    const answerOptions = get(question, 'answers');
    const {
      noteRule
    } = this.state;
    if (!includes(['optional', 'required'], noteRule)) {
      return null;
    }
    const selectedAnswerOptions = uniq(answerOptions.filter(answerItem => userAnswers.includes(answerItem.answer)));
    const selectedDescriptions = uniq(selectedAnswerOptions.map(ao => get(ao, 'noteDesc')).filter(Boolean));
    return <Wrap>
        <Textarea value={getUserNoteByQuestionId(state, questionId)} onChange={e => {
        updateNote({
          questionId,
          note: e.target.value
        });
      }} size="compact" placeholder={noteRule} />
        * {noteRule}
        {!isEmpty(selectedDescriptions) && selectedDescriptions.map(desc => <div key={desc}>{desc}</div>)}
      </Wrap>;
  }
}